import {
  AHIcon,
  AHWidgetTitleText,
  AHWidgetTitleWrapper,
  ColorType,
  useScaleFactor,
} from "arkh";
import React from "react";
import { Text } from "react-native";

export function WidgetNoteTitle(props: {
  title: React.ReactNode;
  locked: boolean;
  textColor: ColorType;
  enableTextShadow: boolean;
}) {
  const scaleFactor = useScaleFactor();
  return (
    <AHWidgetTitleWrapper spaceHorizontal="none" spaceTop="none">
      <AHWidgetTitleText
        spaceTop="small"
        spaceHorizontal="small"
        enableTextShadow={props.enableTextShadow}
        color={props.textColor}
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {props.locked ? (
          <Text
            style={{
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
          >
            <AHIcon
              type="locked"
              color={props.textColor}
              forceSize={12 * scaleFactor}
            />
            {"  "}
          </Text>
        ) : null}
        {props.title}
      </AHWidgetTitleText>
    </AHWidgetTitleWrapper>
  );
}
